import React, { useRef } from 'react';
import styled from 'styled-components';
import { UnstyledButton } from '../../Buttons';
import { scrollTo } from '../../../utils/transitions';
import { NAV_HEADER_HT } from '../../../constants';
import media, { isWindowMobile } from '../../../utils/media';
import { isFieldValid } from '../../../utils/validation';
import { TextWithIndicator } from '../../ComponentWrappers';
import { OnClickFocusWrapper } from '../../UtilityWrappers';
import { RichTextSpan } from '../../Typography';
import { getParsedField } from '../../../utils/helpers';
const ButtonContainer = styled(UnstyledButton) `
  position: relative;
  height: 100%;
  color: ${({ theme }) => theme.primaryBlack};
  width: 100%;
  cursor: pointer;
  background-color: ${({ theme, isSelected }) => (isSelected ? theme.primaryWhite : theme.greyLight)};
  padding: 0 20px;

  :hover {
    .tab-label {
      color: ${({ theme }) => theme.primaryRed};
    }
  }
`;
const Label = styled(RichTextSpan) `
  font-family: ${({ theme }) => theme.fontFamilyBold};
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.005em;

  ${media.tablet} {
    font-size: 18px;
    line-height: 22px;
  }
`;
export const Tab = ({ isSelected, field, index, onClick, itemId }) => {
    if (!isFieldValid(field)) {
        return null;
    }
    const ref = useRef(null);
    const parsedLabel = getParsedField(field);
    const navHeaderOffset = isWindowMobile() ? NAV_HEADER_HT.TABLET : NAV_HEADER_HT.DESKTOP;
    return (React.createElement(OnClickFocusWrapper, null,
        React.createElement(ButtonContainer, { ref: ref, role: "tab", isSelected: isSelected, "aria-selected": isSelected, "aria-expanded": isSelected, "aria-controls": isSelected ? `panel-${index}-${itemId}` : undefined, id: `tab-${index}-${itemId}`, onClick: () => {
                onClick();
                setTimeout(() => {
                    scrollTo(0, ref.current.offsetTop - navHeaderOffset, 'smooth');
                }, 250);
            } },
            React.createElement(TextWithIndicator, { isSelected: isSelected },
                React.createElement(Label, { className: "tab-label", field: parsedLabel })))));
};
// container to group multiple Tabs
export const TabList = styled.ul.attrs({
    role: 'tablist',
}) `
  width: 100%;
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
  outline: none;
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.primaryWhite};
`;
